import { useState, useEffect } from 'react';

function getSessionStorageOrDefault(key) {
  const stored = sessionStorage.getItem(key);
  if (!stored) {
    return null;
  }
  return JSON.parse(stored);
}

export function useSessionStorage(key, defaultValue) {
  const [value, setValue] = useState(
    getSessionStorageOrDefault(key, defaultValue),
  );

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}

export function deleteSessionUser() {
  sessionStorage.removeItem('userData');
}
